var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAsset9(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1926.32014 471.25064",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fefffe;}.cls-2{fill:#e4e6e6;}.cls-3{fill:#cbcccf;}.cls-4{fill:#24bd2d;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M716.87055,136.38658h16.61611V318.64672H685.97561V237.64145l-38.68589,40.50608H642.098l-38.4239-40.50608v81.00527h-47.511V136.38658h17.13322l71.139,78.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M826.97125,259.71123v58.93549h-47.2525v-181.743H892.91516v41.54718H826.97125V218.171H885.3862v41.54028Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1010.79992,134.56639c36.60716.262,74.77251,19.2154,83.59766,64.38916h-45.6943c-7.529-15.575-19.4705-21.80778-37.90336-21.80778-29.34019,0-45.17721,22.84887-45.17721,50.62743,0,30.11584,17.65376,49.84834,45.17721,49.84834,18.69141,0,30.63294-4.92968,38.941-22.32489h-38.68245V215.05457h85.93495c1.04109,18.1743,1.04109,35.56951-5.19167,53.22671-12.98263,37.89991-47.51105,52.44073-81.00183,52.44073-46.21485,0-92.94681-30.89494-93.2088-92.94681C917.85311,165.72333,964.58507,134.56639,1010.79992,134.56639Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1243.96328,139.765l30.89839,96.58029h.77564l8.04951-30.89494,23.10743-68.54663h46.21485v7.01186l-63.08951,176.55137h-26.74436l-29.0782-87.5h-.77565l-29.08164,87.5h-25.69982l-63.86861-176.55137v-7.01186h46.9905l23.366,68.54663,8.04951,30.89494h.77909l30.37784-96.58029Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1369.12535,228.0372c0-125.66194,186.41417-125.66194,186.41417,0C1555.53952,353.95423,1369.12535,353.95423,1369.12535,228.0372Zm138.90312,0c0-65.43026-91.13007-65.43026-91.13007,0C1416.8984,293.98455,1508.02847,293.98455,1508.02847,228.0372Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1744.04966,311.89685v6.74987h-51.92708L1660.9691,265.1649h-24.14852v53.48182h-46.47341v-181.743h79.70563c71.39758.262,84.38021,86.19695,38.42735,117.35388Zm-73.99686-133.446c-10.90389-.262-22.32488,0-33.23222,0v45.42886h33.23222C1695.239,223.87972,1696.53516,178.706,1670.0528,178.45086Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1841.42284,261.53142l-34.79042,57.1153h-48.5487v-7.01186l58.6735-89.30644L1764.313,143.91554v-7.01186h47.51105l29.59875,47.25595h1.29964l30.37439-47.25595h46.73195v7.01186l-52.44417,78.41288,58.93549,89.30644v7.01186h-48.81069l-34.52842-57.1153Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 467.86169,
    height: 471.25064
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M467.79005,118.99079V471.25064h-353.438S473.68068,118.99079,467.79005,118.99079Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.07164,352.25986V0h353.438S-5.819,352.25986.07164,352.25986Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M340.3908,100.96487H364.944V370.28578h-70.2058V250.58646l-57.16511,59.85475h-7.6716l-56.778-59.85475V370.28578h-70.2058V100.96487H128.235L233.35522,217.59758Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset9);
export default __webpack_public_path__ + "static/media/Asset-9.1e7d559bf08bb2fcb085ff900a90f818.svg";
export { ForwardRef as ReactComponent };